import React from 'react'
import { Card, CardContent, CardHeader, Input, Label, Separator, Table, Tr, Th, Td, Button } from '@/shared/ui'
import { fetchDbHealth, estimateCapacity, DEFAULT_BYBIT_RATE } from '@/modules/reports/services/reportsService'

export default function ReportsPage() {
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState<string | null>(null)
  const [reqPerMonitor, setReqPerMonitor] = React.useState<number>(() => Number(localStorage.getItem('rep.reqPerMonitor') || 1))
  const [health, setHealth] = React.useState<Awaited<ReturnType<typeof fetchDbHealth>> | null>(null)

  async function load() {
    setLoading(true)
    setError(null)
    try {
      const h = await fetchDbHealth()
      setHealth(h)
    } catch (e: any) {
      setError(e?.message || 'Falha ao carregar relatório')
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => { load() }, [])
  React.useEffect(() => { localStorage.setItem('rep.reqPerMonitor', String(reqPerMonitor || 1)) }, [reqPerMonitor])

  const est = health ? estimateCapacity({ health, bybit: DEFAULT_BYBIT_RATE, reqPerMonitorPerMin: reqPerMonitor || 1 }) : null

  return (
    <div className="mx-auto max-w-[1200px]">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold">Relatórios do Sistema</h1>
        <p className="text-sm text-foreground/70">Saúde do banco e estimativa de capacidade considerando limites da Bybit.</p>
      </div>

      {error && <div className="mb-4 rounded-md border border-destructive/30 bg-destructive/10 p-2 text-sm text-destructive-foreground">{error}</div>}

      <div className="grid gap-4 md:grid-cols-3">
        <Card><CardHeader className="text-sm">Ativos Ativos</CardHeader><CardContent className="text-3xl font-semibold">{health?.assetsActive ?? (loading? '…':'0')}</CardContent></Card>
        <Card><CardHeader className="text-sm">Monitores Ativos</CardHeader><CardContent className="text-3xl font-semibold">{health?.monitorsActive ?? (loading? '…':'0')}</CardContent></Card>
        <Card><CardHeader className="text-sm">Oportunidades Ativas</CardHeader><CardContent className="text-3xl font-semibold">{health?.opportunitiesActive ?? (loading? '…':'0')}</CardContent></Card>
      </div>

      <Separator className="my-6" />

      <div className="grid gap-4 md:grid-cols-2">
        <Card>
          <CardHeader className="text-sm font-medium">Limites Bybit (v5)</CardHeader>
          <CardContent className="space-y-2 text-sm">
            <div>Requests/min: <b>{DEFAULT_BYBIT_RATE.reqPerMinute}</b></div>
            <div>Requests/sec: <b>{DEFAULT_BYBIT_RATE.reqPerSecond}</b></div>
            <div className="pt-2">
              <Label>Req/monitor por minuto</Label>
              <Input type="number" min={0.1} step={0.1} value={reqPerMonitor} onChange={(e)=> setReqPerMonitor(Number(e.target.value))} className="mt-1 w-40" />
            </div>
            {est && (
              <div className="pt-2 space-y-1">
                <div>Uso atual/min: <b>{est.currentPerMin.toFixed(1)}</b></div>
                <div>Capacidade restante/min: <b>{est.remainingPerMin.toFixed(1)}</b></div>
                <div>Média monitores/ativo: <b>{est.avgMonitorsPerAsset.toFixed(2)}</b></div>
                <div>Ativos adicionais estimados: <b>{est.additionalAssetsPossible}</b></div>
              </div>
            )}
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="text-sm font-medium">OHLCV – Distribuição</CardHeader>
          <CardContent>
            {loading ? (
              <div className="text-sm text-foreground/70">Carregando…</div>
            ) : (
              <div className="overflow-x-auto">
                <Table>
                  <thead><Tr><Th>TF</Th><Th>Linhas</Th><Th>Último candle</Th></Tr></thead>
                  <tbody>
                    {health?.candlesByTf.map((r)=> (
                      <Tr key={r.timeframe}><Td>{r.timeframe}</Td><Td>{r.rows}</Td><Td>{r.latest ?? '-'}</Td></Tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </CardContent>
        </Card>
      </div>

      <div className="mt-6 flex gap-2">
        <Button onClick={load} disabled={loading}>Atualizar</Button>
      </div>
    </div>
  )
}

